<div class="eleman-panel" *ngIf="elemanKopyasi">
  <nz-card [nzBordered]="false" class="eleman-card">
    <div class="eleman-header">
      <div class="eleman-baslik">
        <nz-tag [nzColor]="'blue'">{{ getTipEtiketi() }}</nz-tag>
        <input
          nz-input
          [(ngModel)]="elemanKopyasi.ad"
          (blur)="adDegistir()"
          class="eleman-ad-input"
          placeholder="Eleman adi" />
      </div>

      <div class="eleman-aktiflik">
        <span class="aktiflik-etiket">Aktif:</span>
        <nz-switch
          [(ngModel)]="elemanKopyasi.aktif"
          (ngModelChange)="aktiflikDegistir()">
        </nz-switch>
      </div>
    </div>

    <nz-divider></nz-divider>

    <div class="parametreler-listesi">
      <div *ngFor="let param of getParametreler()" class="parametre-grup">
        <label class="parametre-etiket">{{ param.etiket }}</label>

        <!-- Number Input -->
        <nz-input-number
          *ngIf="param.tip === 'number'"
          [ngModel]="getParametreDeger(param.ad)"
          (ngModelChange)="parametreGuncelle(param.ad, $event)"
          [nzMin]="param.min"
          [nzMax]="param.max"
          [nzStep]="param.step"
          class="parametre-input"
          style="width: 100%">
        </nz-input-number>

        <!-- Slider -->
        <div *ngIf="param.tip === 'slider'" class="parametre-slider-container">
          <nz-slider
            [ngModel]="getParametreDeger(param.ad)"
            (ngModelChange)="parametreGuncelle(param.ad, $event)"
            [nzMin]="param.min"
            [nzMax]="param.max"
            [nzStep]="param.step"
            [nzTooltipVisible]="'always'">
          </nz-slider>
        </div>

        <!-- Select -->
        <nz-select
          *ngIf="param.tip === 'select'"
          [ngModel]="getParametreDeger(param.ad)"
          (ngModelChange)="parametreGuncelle(param.ad, $event)"
          style="width: 100%">
          <nz-option
            *ngFor="let secenek of param.secenekler"
            [nzValue]="secenek"
            [nzLabel]="secenek">
          </nz-option>
        </nz-select>

        <!-- Switch -->
        <nz-switch
          *ngIf="param.tip === 'switch'"
          [ngModel]="getParametreDeger(param.ad)"
          (ngModelChange)="parametreGuncelle(param.ad, $event)">
        </nz-switch>
      </div>
    </div>

    <nz-divider></nz-divider>

    <div class="eleman-aksiyonlar">
      <button nz-button nzType="default" nzBlock (click)="klonla()">
        <i nz-icon nzType="copy"></i>
        Klonla
      </button>
      <button nz-button nzType="default" nzDanger nzBlock (click)="sil()">
        <i nz-icon nzType="delete"></i>
        Sil
      </button>
    </div>
  </nz-card>
</div>
